<template>
  <div>
    <div class="widget-container" :data-balloon="enterNow" data-balloon-pos='up left' v-if="showStartProject && this.hideStartProjectAdmin">
      <div
           class="widget no-print"
           aria-label="Press enter to start a project"
           tabindex="0"
           @keypress.enter.space="openChooseTemplateModal"
           @click="openChooseTemplateModal">
        <i class="fal fa-plus"></i>
        <span class="text"
              :class="{'text-heise': $isHeise}">
          {{ $t('homepage.start')}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>

import componentState from '@/mixins/component-state'
import auth from '@/mixins/auth'
import ajas from '@/mixins/ajas'
export default {
  mixins: [componentState, ajas, auth],
  data: function () {
    return {
      showChooseTemplateModal: false
    }
  },
  computed: {
    enterNow: function () {
      return this.isAfterAjasReleaseDate ? 'Submission period ended' : false
    },
    hideStartProjectAdmin: function () {
      if (this.$route.name !== 'admin' && this.$route.name !== 'adminWithPath') return true
      return false
    },
    hideStartProject: function () {
      if (this.isCreatePage) {
        return true
      }
      const route = this.$route.name
      if (route === 'admin' || route === 'messaging' || route === 'resetPassword') {
        return true
      }
      if (this.$isYSC && route === 'landingRedirect') {
        return true
      }

      if ((this.$isYSC && !this.isLoggedIn) || (this.$isYSC && !this.currentUser?.isPortal && !this.isAdmin)) {
        return true
      }

      return false
    },
    isCreatePage: function () {
      return this.$route.params.fromTemplate
    },
    showStartProject: function () {
      const showForEvent = this.$store.getters.shouldShowWidget
      return (showForEvent && !this.hideStartProject) || this.isAdmin
    }
  },
  methods: {
    openChooseTemplateModal: function () {
      if (this.$isProjectboard) {
        if (!this.isLoggedIn || (this.isLoggedIn && !this.isAdmin)) {
          this.$router.push({ name: 'contact' })
          return
        }
      }
      this._callback('openChooseTemplateModal')
    },
    close: function () {
      this.showChooseTemplateModal = false
    }
  }
}
</script>
<style lang="scss" scoped>
  @import '~styles/utils.scss';
  $widget-width:  170px;
  .widget {
    background: $primary-gradient;
    border-radius: 0 2rem 2rem 0;
    display: flex;
    align-items: center;
    height: 3rem;
    color: white;
    padding: .8rem;
    position: fixed;
    left: 0;
    top: none;
    bottom: 4rem;
    cursor: pointer;
    font-weight: bold;
    font-size: 0.9rem;
    z-index: 1;

    width: 3rem;
    -webkit-transition: width .2s;
    -moz-transition: width .2s;
    -o-transition: width .2s;
    -ms-transition: width .2s;
    transition: width .2s;

    white-space: nowrap;
    overflow: hidden;

    i {
      font-size: 1.5rem;
    }

    .text {
      display: none;
      -webkit-transition: opacity .2s ease-in;
      -moz-transition: opacity .2s ease-in;
      -o-transition: opacity .2s ease-in;
      -ms-transition: opacity .2s ease-in;
      transition: opacity .2s ease-in;
    }

    &:hover, &:focus {
      width: 200px;
      .text {
        // font-family: 'Montserrat', sans-serif;
        font-size: 1rem;
        padding-left: 10px;
        display: inline-block;
      }
      .text-heise {
        // font-family: 'Montserrat', sans-serif;
        font-size: 1rem;
        padding-left: 3px;
        display: inline-block;
      }
    }
  }
  .widget-container {
    height: 6.75rem;
    position: fixed;
    z-index: 5;
    bottom: 50px;
    padding-left: 2rem;
  }
</style>
